import { useState } from 'react';
import { QueryResult } from '../../models/QueryResult';
import UbsUniprotComponent from '../ubs-uniprot/UbsUniprotComponent';
import './clusters.css';

interface ClustersComponentProps {
   query: QueryResult;
}

const ClustersComponent = (props: ClustersComponentProps): React.JSX.Element => {
   const [activeTab, setActiveTab] = useState<number>(0);
   const activateTab = (clickedTab: number): void => {
      if (activeTab === clickedTab) {
         return;
      }
      setActiveTab(clickedTab);
   };

   return (
      <div className="clusters-container">
         {props.query.ubs && props.query.ubs.uniprot_infos ? (
            <>
               <div className="clusters-tabs">
                  <div className="clusters-tabs-label">Uniprot IDs:</div>
                  <div className="clusters-tabs-buttons">
                     {props.query.ubs.uniprot_infos.map((uniprot_info, index: number) => (
                        <button
                           className={`clusters-tab${index === activeTab ? ' active' : ''}`}
                           onClick={(): void => activateTab(index)}
                           key={index}
                        >
                           {uniprot_info.uniprot_id}
                        </button>
                     ))}
                  </div>
               </div>
               {props.query.ubs.uniprot_infos.map((uniprot_info, index: number) => (
                  <div id={`tab-${uniprot_info.uniprot_id}`} key={index}>
                     <div className={`clusters-tab-content${index === activeTab ? ' active' : ''}`}>
                        <UbsUniprotComponent isInsideDbEntryTab={true} ubs_info={uniprot_info} />
                     </div>
                  </div>
               ))}
            </>
         ) : (
            <div className="no-clusters-message">
               <div className="no-clusters-icon">🔗</div>
               <div>Cluster analysis is not yet available for this entry.</div>
            </div>
         )}
      </div>
   );
};

export default ClustersComponent;
